module.exports = __webpack_public_path__ + "img/logo.8ba502f0.png";